import React from "react";
import { BOT_CHANNEL } from "../../../../contexts/bots/BotsContext";
import { useTranslation } from "../../../../hooks/useLocalization";
import { ViberIcon } from "../bodies/Viber";
import ChannelCard from "./ChannelCard";

const ChannelViberCard = (props) => {
  const { t } = useTranslation();
  const { channelName, channel, handlers } = props;
  const { url, validated } = channel;
  return (
    <ChannelCard
      {...props}
      name={t(BOT_CHANNEL.title(channelName))}
      icon={ViberIcon}
      handlers={{
        ...handlers,
        onLink: url && validated ? handlers.onLink : null,
      }}
    />
  );
};

export default ChannelViberCard;
